import React, { createContext, useContext } from 'react';

const TemplateConfigContext = createContext({
  showHeader: false,
  showFooter: false,
  pageSize: {},
});

export const TemplateConfigProvider = ({
  showHeader,
  showFooter,
  pageSize,
  children,
}) => (
  <TemplateConfigContext.Provider value={{ showHeader, showFooter, pageSize }}>
    {children}
  </TemplateConfigContext.Provider>
);

export const useTemplateConfig = () => useContext(TemplateConfigContext);
